<template>
  <v-container class="mt-0">
    <v-layout row wrap justify-center class="mt-3">
      <v-flex xs12 class="text-xs-center mb-2">
        <h1>All Trials</h1>
      </v-flex>
      <v-flex xs12 align-content-space-between mt-4 mb-0 ml-0 mr-0>
        <v-card class="info" v-for="(item, index) in trials" v-bind:key="item.trialId"  :to="'/trials/' + item.trialId">
          <v-list class="listItems">
              <v-list-tile class="pl-2" avatar>
                  <v-list-tile-avatar>
                    <span class="status">
                      <span :class="enrollment(index).enrollmentName"></span><br>
                    </span>
                  </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title>
                    {{ item.trialName }}
                  </v-list-tile-title>
                  <v-list-tile-sub-title><span>{{ enrollment(index).enrollmentName }}</span><span> - {{ locations(index).locationName }}</span></v-list-tile-sub-title>
                  <!-- <v-list-tile-sub-title>{{ item.trialDate | date }}</v-list-tile-sub-title> -->
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-btn light flat icon right ripple :to="'/trials/' + item.trialId">
                    <v-icon v-bind:color="item.active ? 'grey' : 'grey'">navigate_next</v-icon>
                  </v-btn>
                </v-list-tile-action>
                <v-list-tile-action class="" v-if="userIsAuthenticated">
                  <v-btn light icon right flat :to="'/trials/' + item.trialId + '/edit'" class="">
                    <v-icon small light class="text--lighten-2">edit</v-icon>
                  </v-btn>
                </v-list-tile-action>
              </v-list-tile>
          </v-list>
        </v-card>
      </v-flex>
      <v-flex xs12 mb-4 v-if="userIsAuthenticated">
        <v-card :to="'/trial/new'">
          <v-card-text class="primaryLight editDialogsRow" v-if="userIsAuthenticated">
            Add Trial
            <v-icon class="text-xs-right">add</v-icon>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  props: ['id'],
  data () {
    return {
    }
  },
  computed: {
    trials () {
      var loadedTrialss = this.$store.getters.loadedTrials
      return loadedTrialss.sort((a, b) => {
        var EPa = this.$store.getters.loadedEnrollment(a.trialEnrollment)
        var EPb = this.$store.getters.loadedEnrollment(b.trialEnrollment)
        return (EPa.enrollmentPriority > EPb.enrollmentPriority) ? 1 : ((EPb.enrollmentPriority > EPa.enrollmentPriority) ? -1 : 0)
      })
    },
    userIsAuthenticated () {
      return this.$store.getters.user !== null && this.$store.getters.user !== undefined
    },
    loading () {
      return this.$store.getters.loading
    },
    enrollmentsss () {
      if (this.trial.trialEnrollment) {
        var val = []
        val = this.$store.getters.loadedEnrollment(this.trial.trialEnrollment)
        return val.enrollmentName
      } else {
        return null
      }
    }
  },
  methods: {
    trial (index) {
      return this.$store.getters.loadedTrial(this.trials[index].trialId)
    },
    enrollment (index) {
      console.log('CURRENT loadedEnrollment ITEM: ' + this.$store.getters.loadedEnrollment(this.trials[index].trialId))
      var val = this.$store.getters.loadedEnrollment(this.trials[index].trialEnrollment)
      return val
    },
    locations (index) {
      console.log('CURRENT loadedLocation ITEM: ' + this.$store.getters.loadedLocation(this.trials[index].trialLocations))
      var val = this.$store.getters.loadedLocation(this.trials[index].trialLocations[0])
      return val
    },
    onDeleteTrial (trial) {
      this.$store.dispatch('deleteTrialData', trial)
      this.$router.push('/trials')
    }
  },
  mutations: {
    trials (newArray) {
      this.$store.dispatch('loadTrials')
    }
  }
}
</script>

<style lang="scss" scoped>
  span.status{
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding-right: 9px;
    span{
      height: 10px;
      width: 10px;
      border-radius: 10px;
      &.Enrolling{
        background: green;
      }
      &.Not.Enrolling{
        background: red;
      }
      &.Pending {
        background: orange;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// Trials.vue?43bfb2e4